import { Injectable, inject } from '@angular/core';
import { Permission } from '@interfaces/a-organizar/permission';
import { UserService } from '@services/http/user.service';
import { Observable, catchError, map, of, shareReplay } from 'rxjs';
import {
  RoleCatalogIndex,
  indexCatalog,
} from '@app/features/dashboard/group-list/group-list.utils';

/**
 * Catálogo de permissões por tipo de usuário (`GET permissions/all?role=`), já indexado para a lista de grupos
 * (card 3902). Uma chamada por papel presente na lista, guardada enquanto o app estiver aberto: voltar da edição
 * para a lista não busca de novo. Falha não fica no cache (a próxima abertura tenta de novo) e vira `null`: a lista
 * mostra os números pela regra do sufixo e sem a linha de módulos.
 */
@Injectable({ providedIn: 'root' })
export class RoleCatalogService {
  private readonly userService = inject(UserService);
  private readonly cache = new Map<string, Observable<RoleCatalogIndex | null>>();

  getIndex(roleId: string): Observable<RoleCatalogIndex | null> {
    const cached = this.cache.get(roleId);
    if (cached) return cached;

    const request$ = this.userService.getAllUsersPermissions(roleId).pipe(
      map((catalog: Permission[] | null) => indexCatalog(catalog ?? [])),
      catchError(() => {
        this.cache.delete(roleId);
        return of(null);
      }),
      shareReplay({ bufferSize: 1, refCount: false })
    );
    this.cache.set(roleId, request$);
    return request$;
  }
}
